export default __webpack_public_path__ + "static/media/0429 매트리스_001.0708ed02.jpg";